// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weddingCard_weddingCard__qviv- {
  background-color: var(--white);
  border-radius: var(--border-radius-large);
  padding: 16px;
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}
.weddingCard_weddingCard__qviv- .weddingCard_cardHeader__7m\\+gI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.weddingCard_weddingCard__qviv- .weddingCard_cardHeader__7m\\+gI .weddingCard_cardTitle__LNLT4 {
  font: var(--h6);
  font-weight: 600;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/wedding-card/weddingCard.module.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,yCAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;AACZ","sourcesContent":[".weddingCard {\r\n    background-color: var(--white);\r\n    border-radius: var(--border-radius-large);\r\n    padding: 16px;\r\n    border: 1px solid var(--border);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    height: 100%;\r\n\r\n    .cardHeader {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 10px;\r\n\r\n        .cardTitle {\r\n            font: var(--h6);\r\n            font-weight: 600;\r\n            text-transform: capitalize;\r\n        }\r\n    }\r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"weddingCard": `weddingCard_weddingCard__qviv-`,
	"cardHeader": `weddingCard_cardHeader__7m+gI`,
	"cardTitle": `weddingCard_cardTitle__LNLT4`
};
export default ___CSS_LOADER_EXPORT___;
